window.JobApplyDisclaimerForm = function (scope) {
    var self = this;
    var formName = "job-apply-disclaimer-form";
    var _protected = BaseForm.call(self, formName, scope);

    self.data = {};
    // GDPR disclaimers
    self.disclaimers = {};

    self.setDisclaimers = function (disclaimers) {
        disclaimers = disclaimers || [];

        for (var i in disclaimers) {
            self.disclaimers[disclaimers[i].type] = disclaimers[i].content;
        }
    };

    self.save = function() {
        var defer = $q.defer();

        defer.resolve();

        return defer.promise;
    };

    self.load = function () {

    };
};
